/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agents_Name_Image_GenerationInputs */

const tr_agents_name_image_generation = /** @type {(inputs: Agents_Name_Image_GenerationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Görsel Üretimi`)
};

const en_agents_name_image_generation = /** @type {(inputs: Agents_Name_Image_GenerationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image Generation`)
};

const de_agents_name_image_generation = /** @type {(inputs: Agents_Name_Image_GenerationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilderzeugung`)
};

const ru_agents_name_image_generation = /** @type {(inputs: Agents_Name_Image_GenerationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Генерация изображений`)
};

/**
* | output |
* | --- |
* | "Image Generation" |
*
* @param {Agents_Name_Image_GenerationInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const agents_name_image_generation = /** @type {((inputs?: Agents_Name_Image_GenerationInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Name_Image_GenerationInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agents_name_image_generation(inputs)
	if (locale === "de") return de_agents_name_image_generation(inputs)
	if (locale === "ru") return ru_agents_name_image_generation(inputs)
	return tr_agents_name_image_generation(inputs)
});